import React from 'react';

import atribuirTreinoStaffImg from '../../../../assets/mockups/atribuir-treino-mobile-staff.png';
import fichaTreinoAlunoImg from '../../../../assets/mockups/ficha-treino-mobile-aluno.png';
import relatoriosAvancadosImg from '../../../../assets/mockups/relatorios-avancados-web.png';
import { Reveal } from '../../../../components/Reveal';
import { TiltCard } from '../../../../components/TiltCard';
import { Section, SectionInner } from '../../styles';
import {
  DashboardMockup,
  Eyebrow,
  Footnote,
  Heading,
  ImageColumn,
  IntroBlock,
  List,
  ListItem,
  PhoneMockup,
  Row,
  Stack,
  TextColumn,
  WideRow,
} from './styles';

const ProductShowcase: React.FC = () => {
  return (
    <Section>
      <SectionInner>
        <Stack>
          <Row>
            <Reveal direction="left">
              <TextColumn>
                <Eyebrow>Aplicativo do aluno · iOS &amp; Android</Eyebrow>
                <Heading>
                  A melhor experiência de treino na palma da mão.
                </Heading>
                <List>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Visualização clara de fichas, séries, repetições e
                      intervalos.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Demonstrativos e orientações de execução para cada
                      exercício.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Histórico de evolução, cargas e conquistas por insígnias.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Canal direto de comunicação com os instrutores da
                      academia.
                    </span>
                  </ListItem>
                </List>
              </TextColumn>
            </Reveal>
            <Reveal direction="right">
              <ImageColumn>
                <TiltCard baseRotateY={-10} baseRotate={-2}>
                  <PhoneMockup>
                    <img
                      src={fichaTreinoAlunoImg}
                      alt="Ficha de treino no app do aluno"
                    />
                  </PhoneMockup>
                </TiltCard>
              </ImageColumn>
            </Reveal>
          </Row>

          <Row>
            <Reveal direction="left">
              <ImageColumn order={2}>
                <TiltCard baseRotateY={10} baseRotate={2}>
                  <PhoneMockup>
                    <img
                      src={atribuirTreinoStaffImg}
                      alt="Criação rápida de ficha no app staff"
                    />
                  </PhoneMockup>
                </TiltCard>
              </ImageColumn>
            </Reveal>
            <Reveal direction="right">
              <TextColumn order={1}>
                <Eyebrow>App staff · instrutores</Eyebrow>
                <Heading>
                  Mobilidade e celeridade para a equipe no dia a dia.
                </Heading>
                <List>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Criação e edição rápida de fichas de treino direto na sala
                      de musculação.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Dashboard simplificado para acompanhar alunos presentes em
                      tempo real.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Chat integrado para responder dúvidas instantaneamente.
                    </span>
                  </ListItem>
                </List>
              </TextColumn>
            </Reveal>
          </Row>

          <div style={{ display: 'grid', gap: 34 }}>
            <IntroBlock>
              <Eyebrow>Painel web admin · gestão completa</Eyebrow>
              <Heading>
                O centro de controle total para gestores e administrativos.
              </Heading>
            </IntroBlock>
            <WideRow>
              <Reveal direction="left">
                <List>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Dashboard 360° com métricas de alunos ativos, frequência e
                      relatórios financeiros.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Gerenciador de retenção com alertas automáticos de risco
                      de evasão.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Biblioteca master de exercícios, gerenciamento de equipe e
                      permissões.
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>—</span>
                    <span>
                      Controle de inadimplência, relatórios exportáveis e
                      automação de disparos (Push/E-mail).
                    </span>
                  </ListItem>
                </List>
              </Reveal>
              <TiltCard baseRotateY={-6}>
                <DashboardMockup>
                  <img
                    src={relatoriosAvancadosImg}
                    alt="Relatórios avançados no painel web"
                  />
                </DashboardMockup>
              </TiltCard>
            </WideRow>
            <Footnote>
              Alguns recursos podem não estar disponíveis em todos os planos.
              Consulte a seção de preços para mais detalhes.
            </Footnote>
          </div>
        </Stack>
      </SectionInner>
    </Section>
  );
};

export { ProductShowcase };
